import React from "react";
import styles from "./AboutBloveToken.module.scss";
import Image from "next/image";

const AboutBloveToken = () => {
  return (
    <div className={styles.AboutBloveToken}>
      <div className={styles.conatiner}>
        <div className={styles.image}>
          <Image
            src="/assets/Image/hand.png"
            width={657}
            height={482}
            className={styles.img}
            alt="image"
          />
        </div>

        <div className={styles.content}>
          <h1 className={styles.title}>
            What is <br />{" "}
            <span className={styles.titleSpan}>B-Love Token? </span>
          </h1>

          <p className={styles.text}>
            B-Love Token (BLV) is a community-reward token deployed on the BFIC
            Blockchain. The BLV token has a maximum supply of 20 billion tokens,
            and will follow a progressive supply burn mechanism to elevate the
            internal value.
          </p>

          <div className={styles.flexContent}>
              <div className={styles.col}>
                 <h4 className={styles.titleContent}>Initial Supply:</h4>
                 <h3 className={styles.number}>3 Trillion</h3>
              </div>

              <div className={styles.col}>
                 <h4 className={styles.titleContent}>Maximum Supply:</h4>
                 <h3 className={styles.number}>20 Billion</h3>
              </div>

              <div className={styles.col}>
                 <h4 className={styles.titleContent}>Supply Burn:</h4>
                 <h3 className={styles.number}>10% Every Month</h3>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutBloveToken;
